module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/assets/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles